import React from 'react';
import classNames from 'classnames';

import { SocialMediaItem } from './SocialMediaItem';
import { SocialMediaProps } from './exportedTypes';

import styles from './SocialMedia.module.scss';

export const SocialMedia = ({
  className,
  children,
  ...props
}: React.PropsWithChildren<SocialMediaProps>): React.ReactElement => (
  <div className={classNames(styles.SocialMedia, className)} {...props}>
    {children}
  </div>
);

SocialMedia.Item = SocialMediaItem;
